import React from 'react';
import PropTypes from 'prop-types';

const IgAuthLayout = ({ children }) => (
  <div className="c-notifications c-notifications-ig-auth-layout">
    {children}
  </div>
);

IgAuthLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default IgAuthLayout;



// WEBPACK FOOTER //
// ./src/app/notifications/layouts/IgAuthLayout.jsx